import React from 'react'
import { useAppDispatch, useAppSelector } from './useReduxHooks'
import { shallowEqual, useDispatch } from 'react-redux'
import {
  FetchNoficationsRequest,
  UpdateNotificationsRequest,
} from '../redux/reducers/notifications/types'
import * as actions from '../redux/reducers/notifications/service'


const useNotifications = () => {
  const dispatch = useAppDispatch()
  const { notifications, listLoading } = useAppSelector((state) => state.notifications, shallowEqual)
  const [unreadNotificationCount, setUnreadNotificationCount] = React.useState(0)

  React.useEffect(() => {
    let count = 0
    notifications.forEach((notif) => {
      count += notif.read ? 0 : 1
    })
    setUnreadNotificationCount(count)
  }, [notifications])

  const fetchNotifications = (vals: FetchNoficationsRequest) => {
    return dispatch(actions.fetchNotifications(vals))
  }

  const handleUnseenNotification = async (payload: UpdateNotificationsRequest) => {
    return dispatch(actions.updateNotification({ notificationId: payload.notificationId }))
  }

  const handeOpenNotification = () => {
    setUnreadNotificationCount(0)
  }
  return {
    notifications,
    listLoading,
    fetchNotifications,
    unreadNotificationCount,
    handleUnseenNotification,
    handeOpenNotification,
  }
}

export default useNotifications
